import styled from "styled-components";

export const SearchPanelCss = styled.div`
  .content {
    display: flex;
    width: 570px;
    border: 1px solid #eee;
    border-radius: 26px;
    background-color: #fff;
    
    .item {
      flex: 1;
      padding: 10px 20px;
      
      .title {
        font-weight: 600;
        font-size: 12px;
        margin-bottom: 2px;
      }
      .desc {
        color: #717171;

      }

    }
  }

`